import { createFileRoute } from '@tanstack/react-router'

import {
  forbiddenErrorComponent,
  requireGxpEnabled,
  requirePermission,
} from '@/lib/routeGuards'
import { SignaturePolicies } from '@/pages/Settings/SignaturePolicies/SignaturePolicies'

export const Route = createFileRoute('/_app/settings/compliance')({
  component: SignaturePolicies,
  beforeLoad: ({ context }) => {
    requireGxpEnabled(context.pinStatus)
    requirePermission(context.permissions, 'write:gxp_policies')
  },
  errorComponent: forbiddenErrorComponent,
})
